var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTwitchIconNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6B758B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_501_408",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#DEDEDE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_501_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 0L2 3.57143V16.4286H6V20L9.33333 16.4286H12L18 10V0H5.33333ZM16.6667 9.28571L14 12.1429H11.3333L9 14.6429V12.1429H6V1.42857H16.6667V9.28571Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 3.92864H13.3332V8.21435H14.6665V3.92864Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 3.92864H9.66628V8.21435H10.9996V3.92864Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitchIconNew);
export default __webpack_public_path__ + "static/media/social-twitch-icon-new.785086eeeec4507feb3f2e2cdbc87ebd.svg";
export { ForwardRef as ReactComponent };